class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.header-unique-id');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.scrolling = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    let announcement = document.querySelector('.announcement-bar');
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${parseInt(announcement.getBoundingClientRect().bottom)}px`
    );



    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-scrolled', 'shopify-section-header-sticky');


    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-scrolled', 'shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-scrolled', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);


if (!customElements.get('dropdown-menu')) {
  customElements.define(
    'dropdown-menu',

    class DropdownMenuCustom extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.handleLevelTwoHeadlines();
      }

      handleLevelTwoHeadlines() {
        // Moving this code out of DOMContentLoaded listener to ensure it runs immediately when the component is connected
        const level1Headings = this.querySelectorAll('.js-level-1-heading');

        // Add click event listeners to all level-1 headings
        level1Headings.forEach(heading => {
          heading.addEventListener('click', () => { // arrow function to maintain context            
            const handle = heading.getAttribute('data-handle'); // "heading" as it's the current element in the loop

            // Toggle classes for level-1 headings
            level1Headings.forEach(h => {
              h.classList.remove('level1-active');
            });
            heading.classList.add('level1-active');

            // Find level-2 headings
            const level2Headings = this.querySelectorAll('.js-level-2-heading');

            level2Headings.forEach(level2 => {
              if (level2.getAttribute('data-handle') === handle) {
                level2.classList.remove('level-2-hidden');
              } else {
                level2.classList.add('level-2-hidden');
              }
            });
          });
        });
      }
    }
  );
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.menu_buttons = this.querySelectorAll('.js-drawer-btn');    
    this.mainDetailsToggle = this.querySelector('details');    
    this.bindEvents(); 
    
  }

  handleMenuChange(button) {    
    this.menu_buttons.forEach(button => {
      button.classList.remove('btn-active')
    })

    button.classList.add('btn-active')

    const buttonIndex = button.getAttribute('data-index');

    // Find all elements with the class 'menu-drawer__inner-container'
    const innerContainers = document.querySelectorAll('.menu-drawer__inner-container');

    // Iterate through the inner containers to display the correct one
    innerContainers.forEach(container => {
      if (container.getAttribute('data-index') === buttonIndex) {
        container.style.display = 'block'; // Show the matching container
      } else {
        container.style.display = 'none'; // Hide the non-matching containers
      }
    });
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.show-more_btn):not(.mobile-sort-dropdown__trigger)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  //menu drawer opening
  onSummaryClick(event) {    
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || 0;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    // Otvori/zatvori glavni meni (hamburger drawer)
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summaryElement);
      } else {
        this.openMenuDrawer(summaryElement);
      }

      // Za mobilne uređaje postavi visinu viewporta
      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    document.body.classList.add('overflow-hidden-tablet');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    console.log('111')
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');

    if (Array.from(this.menu_buttons).includes(event.target)) {
      this.handleMenuChange(event.target)
    } else { 
      // Otherwise, close the submenu
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initAccordions(); // Call accordion init on attach
  }

 initAccordions() {
    let accordions = document.querySelectorAll('.header-menu__accordion');

    if (accordions) {
        accordions.forEach((headline) => {
            headline.addEventListener('click',  (event) => {
               
               accordions.forEach((acc) => {
                  const accContent = acc.nextElementSibling;
                  const accDetails = acc.parentElement;
                  
                  if (acc !== headline && !accContent.contains(headline)) {
                    // collapse acc
                    accDetails.removeAttribute('open')
                    accContent.style.maxHeight = '0px';
                    accContent.style.opacity = 0;
                    acc.parentElement.classList.remove('menu-drawer__opened-background');

                    const accPlus = acc.querySelector('.menu-icon-plus');
                    const accMinus = acc.querySelector('.menu-icon-minus');
                    if (accPlus && accMinus) {
                      accPlus.style.display = 'block';
                      accMinus.style.display = 'none';
                    }

                    const accNext = acc.querySelector('.menu-next');
                    if (accNext) {
                      accNext.classList.remove('menu-next__rotate');
                    }
                  }
              });
                

                const content = headline.nextElementSibling;
                const plusIcon = headline.querySelector('.menu-icon-plus');
                const minusIcon = headline.querySelector('.menu-icon-minus'); 
                const menuNext = headline.querySelector('.menu-next');                

                if (content.style.maxHeight === "" || content.style.maxHeight === "0px") {
                    if(headline.classList.contains('drawer-L1')) {
                      headline.parentElement.classList.add('menu-drawer__opened-background');
                    } 
                    content.style.maxHeight = content.scrollHeight + "px";
                    content.style.opacity = 1; 
                    if(plusIcon && minusIcon) {
                      plusIcon.style.display = 'none';
                      minusIcon.style.display = 'block';
                    }
                    if(menuNext) {
                      menuNext.classList.add('menu-next__rotate');
                    }
                    
                    let parent = headline.parentElement.parentElement;                                    
                    while (parent) {

                      let parentDetails = parent.classList.contains("header-menu__accordion-root");

                      if (parentDetails) {
                        let parentDetailsElement = parent.querySelector('.header-menu__accordion-content');                                                          
                        parentDetailsElement.style.setProperty('max-height', '1200px', 'important');                        
                        break;
                      }
                      parent = parent.parentElement;
                    }      
                } else {         
                  headline.parentElement.classList.remove('menu-drawer__opened-background');          
                    content.style.maxHeight = "0px";
                    content.style.opacity = 0; 
                    if(plusIcon && minusIcon) {
                      plusIcon.style.display = 'block';
                      minusIcon.style.display = 'none';
                    }
                    if(menuNext) {
                      menuNext.classList.remove('menu-next__rotate');
                    }
                }
            });
        });
    }
  }
  updateParentAccordions(element) {
    let parent = element.parentElement;

    while (parent) {
        if (parent.classList.contains('header-menu__accordion-content')) {
            parent.style.maxHeight = parent.scrollHeight + "px";
        }
        parent = parent.parentElement;
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || 0;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
  if (!elementToFocus) return;
  super.closeMenuDrawer(event, elementToFocus);
  this.header.classList.remove('menu-open');
  window.removeEventListener('resize', this.onResize);

  // Reset accordion states
  const accordions = document.querySelectorAll('.header-menu__accordion');
  accordions.forEach((headline) => {
    const content = headline.nextElementSibling;
    const plusIcon = headline.querySelector('.menu-icon-plus');
    const minusIcon = headline.querySelector('.menu-icon-minus');
    const menuNext = headline.querySelector('.menu-next');

    // Close content
    if (content && content.style) {
      content.style.maxHeight = '0px';
      content.style.opacity = 0;
    }

    // Reset icons
    if (plusIcon && minusIcon) {
      plusIcon.style.display = 'block';
      minusIcon.style.display = 'none';
    }

    // Reset rotation
    if (menuNext) {
      menuNext.classList.remove('menu-next__rotate');
    }

    // Remove background class
    headline.parentElement.classList.remove('menu-drawer__opened-background');
  });

  console.log('Accordion state reset');
}


  onResize = () => {
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    }
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);
